export const premiumValues = {
  livskydd: [
    {
      age: 18,
      premium: 0.000033,
    },
    {
      age: 19,
      premium: 0.000033,
    },
    {
      age: 20,
      premium: 0.0000335,
    },
    {
      age: 21,
      premium: 0.000034,
    },
    {
      age: 22,
      premium: 0.000035,
    },
    {
      age: 23,
      premium: 0.0000355,
    },
    {
      age: 24,
      premium: 0.0000365,
    },
    {
      age: 25,
      premium: 0.000037,
    },
    {
      age: 26,
      premium: 0.0000385,
    },
    {
      age: 27,
      premium: 0.0000395,
    },
    {
      age: 28,
      premium: 0.000041,
    },
    {
      age: 29,
      premium: 0.0000435,
    },
    {
      age: 30,
      premium: 0.000044,
    },
    {
      age: 31,
      premium: 0.000046,
    },
    {
      age: 32,
      premium: 0.000048,
    },
    {
      age: 33,
      premium: 0.0000505,
    },
    {
      age: 34,
      premium: 0.000053,
    },
    {
      age: 35,
      premium: 0.000056,
    },
    {
      age: 36,
      premium: 0.000059,
    },
    {
      age: 37,
      premium: 0.000063,
    },
    {
      age: 38,
      premium: 0.000067,
    },
    {
      age: 39,
      premium: 0.0000715,
    },
    {
      age: 40,
      premium: 0.0000765,
    },
    {
      age: 41,
      premium: 0.000082,
    },
    {
      age: 42,
      premium: 0.000088,
    },
    {
      age: 43,
      premium: 0.000095,
    },
    {
      age: 44,
      premium: 0.000103,
    },
    {
      age: 45,
      premium: 0.0001115,
    },
    {
      age: 46,
      premium: 0.000121,
    },
    {
      age: 47,
      premium: 0.0001315,
    },
    {
      age: 48,
      premium: 0.0001435,
    },
    {
      age: 49,
      premium: 0.0001565,
    },
    {
      age: 50,
      premium: 0.0001715,
    },
    {
      age: 51,
      premium: 0.0001875,
    },
    {
      age: 52,
      premium: 0.0002055,
    },
    {
      age: 53,
      premium: 0.000226,
    },
    {
      age: 54,
      premium: 0.000248,
    },
    {
      age: 55,
      premium: 0.0002735,
    },
    {
      age: 56,
      premium: 0.0003015,
    },
    {
      age: 57,
      premium: 0.0003325,
    },
    {
      age: 58,
      premium: 0.000367,
    },
    {
      age: 59,
      premium: 0.0004055,
    },
    {
      age: 60,
      premium: 0.00044843,
    },
    {
      age: 61,
      premium: 0.0004961,
    },
    {
      age: 62,
      premium: 0.00054928,
    },
    {
      age: 63,
      premium: 0.00060848,
    },
  ],
};
